import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=2e6cb202&scoped=true&"
import script from "./ControlButtons.vue?vue&type=script&lang=js&"
export * from "./ControlButtons.vue?vue&type=script&lang=js&"
import style0 from "./ControlButtons.vue?vue&type=style&index=0&id=2e6cb202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6cb202",
  null
  
)

export default component.exports